var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"size":"lg","title":"Resumenes","hide-footer":"","id":"resumen-caja"}},[_c('view-component',{attrs:{"show_btn_save":_vm.show_btn_save,"model_name":"resumen_caja"},scopedSlots:_vm._u([{key:"table_left_options",fn:function(props){return [_c('btn-pdf',{attrs:{"model_name":"resumen_caja","model":props.model}})]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }